import { getRoleDisplay, USER_ROLES } from '../../constants/roles';
import { getRoleColor, getRoleColorAlpha } from '../../assets/theme/roleColors';

export const CARE_TEAM_COPY = {
  pageTitle: 'Care Circle',
  ownerCta: 'Invite Team Member',
  ownerSummaryTitle: 'Invite overview',
  partnerSummaryTitle: 'Read-only access',
};

const ROLE_COLOR_KEYS = {
  [USER_ROLES.CARE_OWNER]: 'careOwner',
  [USER_ROLES.CARE_PARTNER]: 'carePartner',
  [USER_ROLES.CAREGIVER]: 'caregiver',
  [USER_ROLES.THERAPIST]: 'therapist',
};

export const getReadableRoleLabel = (role) => getRoleDisplay(role).plainLabel || 'Team Member';

export const getTeamRolePresentation = (role, {signsOriginals=false} = {}) => {
  const roleKey = ROLE_COLOR_KEYS[role] || 'careOwner';
  const roleDisplay = getRoleDisplay(role);

  return {
    label: role === USER_ROLES.CAREGIVER && signsOriginals ? 'Staff caregiver' : getReadableRoleLabel(role),
    badge: roleDisplay.badge || 'Access',
    primary: getRoleColor(roleKey, 'primary'),
    secondary: getRoleColor(roleKey, 'secondary'),
    accent: getRoleColor(roleKey, 'accent'),
    chipBg: getRoleColorAlpha(roleKey, 'primary', 0.1),
    chipBorder: getRoleColorAlpha(roleKey, 'primary', 0.2),
  };
};

export const getChildCareOwner = (child) => {
  const owner = child?.users?.care_owner_details || child?.users?.care_owner;

  if (!owner) {
    return null;
  }

  if (typeof owner === 'object') {
    return {
      ...owner,
      role: USER_ROLES.CARE_OWNER,
      name: owner.name || owner.displayName || 'Care Owner',
      displayName: owner.displayName || owner.name || 'Care Owner',
      email: owner.email || '',
    };
  }

  return {
    uid: owner,
    role: USER_ROLES.CARE_OWNER,
    name: 'Care Owner',
    displayName: 'Care Owner',
    email: '',
    photoURL: null,
  };
};

export const collectTeamMembers = (child) => {
  const members = [];
  const owner = getChildCareOwner(child);

  if (owner) {
    members.push(owner);
  }

  if (child?.users?.care_partners) {
    members.push(...child.users.care_partners.map((member) => ({
      ...member,
      role: USER_ROLES.CARE_PARTNER,
    })));
  }

  if (child?.users?.caregivers) {
    members.push(...child.users.caregivers.map((member) => ({
      ...member,
      role: USER_ROLES.CAREGIVER,
    })));
  }

  if (child?.users?.therapists) {
    members.push(...child.users.therapists.map((member) => ({
      ...member,
      role: USER_ROLES.THERAPIST,
    })));
  }

  const seen = new Set();

  return members.filter((member) => {
    const key = member?.uid || member?.email || member?.name;
    if (!key) {
      return false;
    }
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
